/* eslint-disable */
import Dialog from '../modules/dialog';
import { ParamsData } from '../app';
import disclosure from '../modules/disclosure';
import Breakpoint from '../modules/breakpoint';

export default el => {

    const btn_shares = el.querySelector(".shares");
    const dialog = el.querySelector(".modal-shares");
    const myDialog = new Dialog(dialog);
    const url = ParamsData.wp_ajax_url;
    const visu = document.querySelector(".visu");

    btn_shares.onclick = () => myDialog.open();

    // reposition sur dans la colone
    const breakpoint = new Breakpoint(1024);

    const resize = () => {
        dialog.style.inset = `${visu.offsetTop}px  0 0 ${visu.getBoundingClientRect().left}px`;
        dialog.style.width = `${visu.clientWidth}px`;
    }
    breakpoint.under = () => {
        dialog.removeAttribute("style");
        window.removeEventListener("resize", resize);
    }
    breakpoint.above = () => {
        window.addEventListener("resize", resize);
        resize();
    }


    // like
    const btn_like = el.querySelector(".like");
    btn_like.onclick = () => {
        const formData = new FormData();
        formData.append("nonce", btn_like.dataset.nonce);
        formData.append("action", "like_post");
        formData.append("postID", btn_like.dataset.postid);

        const xhr = new XMLHttpRequest();
        xhr.open("POST", url, true);
        xhr.onload = () => {
            const response = JSON.parse(xhr.response);
            console.log(response);
            if (response.likeStatus) {
                btn_like.classList.add('active');
                btn_like.setAttribute("aria-label", "Ne plus aimer l’article")

            } else {
                btn_like.classList.remove('active');
                btn_like.setAttribute("aria-label", "Aimer l’article")
            }
        };
        xhr.send(formData);
    };

    //lang
    const customselect = el.querySelector(".custom-select");
    if (customselect) disclosure(customselect.querySelector("[aria-controls]"));

    // share mobile
    const btn_share = el.querySelector('.btn-shares-mobile');
    btn_share.onclick = () => {
        let url = window.location ;

        navigator.share({
            title: document.title,
            url: url,
        });
    }
}